import React, { useState } from "react";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { Link, useLocation } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import Table from "../../../core/common/dataTable/index";
import useApi from "../../../core/customhook/useApi";
import dayjs from "dayjs";
import Swal from "sweetalert2";
import Loader from "../../../core/common/selfLoder";
import { getFinancialYearList } from "../../../core/common/financialYear";

const LeaveDetailTeamMember = () => {
  const location = useLocation();
  const employee_id = location?.state?.searchValue?.employee_id || "";
  const [modalData, setModalData] = useState<any>({});

  const formatFinancialYear = (year: number) => {
    const nextYearShort = (year + 1).toString().slice(-2);
    return `${year}-${nextYearShort}`;
  };

  const getFinancialYear = () => {
    const today = new Date();
    const year = today.getFullYear(); 
    return formatFinancialYear(year);
  };

  const [finance_year, setFinance_year] = useState(getFinancialYear());

  const {
    data: leaveDetails,
    loading: leave_details_loading,
    error: leave_details_error,
  } = useApi("/api/manager/view-teams-leave-request", {
    method: "POST",
    autoCall: true,
    payload: {
      employee_id: employee_id,
      financial_year: finance_year,
    },
    dependencies:[finance_year]
  });

  const data = leaveDetails?.data.map((item: any, index: number) => {
    return {
      ...item,
      Days: item.days === null ? "------" : item.days
    };
  });
  const columns = [
    {
      title: "EmployeeName",
      dataIndex: "employee_name",
      render: (text: string) => (
        <Link to={all_routes.employeedetails}>{text}</Link>
      ),
      sorter: (a: any, b: any) =>
        a.employee_name.localeCompare(b.employee_name),
    },
    {
      title: "AppDate",
      dataIndex: "application_date",
      render: (text: string) =>
        text ? dayjs(text).format("D MMMM YYYY") : "------",
      sorter: (a: any, b: any) =>
        dayjs(a.application_date).valueOf() - dayjs(b.application_date).valueOf(),
    },

    {
      title: "From",
      dataIndex: "from_date",
      render: (text: string) =>
        text ? dayjs(text).format("D MMMM YYYY") : "------",
      sorter: (a: any, b: any) =>
        dayjs(a.from_date).valueOf() - dayjs(b.from_date).valueOf(),
    },

    {
      title: "To",
      dataIndex: "to_date",
      render: (text: string) =>
        text ? dayjs(text).format("D MMMM YYYY") : "------",
      sorter: (a: any, b: any) =>
        dayjs(a.to_date).valueOf() - dayjs(b.to_date).valueOf(),
    },

    {
      title: "Days",
      dataIndex: "Days",
      sorter: (a: any, b: any) => a.Days - b.Days,
    },
    {
      title: "Type",
      dataIndex: "leave_type",
      sorter: (a: any, b: any) => a.leave_type.localeCompare(b.leave_type),
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text: string) => (
        <span
          className={`badge ${text.toLowerCase().includes("approved") ? "bg-success" : text.toLowerCase().includes("pending") ? "bg-warning" : "bg-danger"
            }`}
        >
          {text}
        </span>
      ),
      sorter: (a: any, b: any) => a.status.localeCompare(b.status),
    },
    {
      title: "Action",
      dataIndex: "actions",
      render: (text: string, record: any) => {
        const isFinalStatus =
          record.status === "APPROVED" || record.status === "REJECTED";
        const iconStyle: React.CSSProperties = {
          cursor: isFinalStatus ? "not-allowed" : "pointer",
          pointerEvents: isFinalStatus ? "none" : "auto",
        };

        return (
          <div className="action-icon d-inline-flex">
            {/* View Icon */}
            <Link
              to="#"
              className="text-info"
              title="View"
              data-bs-toggle="modal"
              data-bs-target={`${record.status === "APPROVED" ? "#approve-modal" : record.status === "REJECTED" ? "#rejected-modal" : "#apply-modal"}`}
              onClick={() => {
                setModalData(record);
              }}
            >
              <i className="ti ti-eye" />
            </Link>

            {/* Approve Icon */}
            <Link
              to="#"
              className="text-success"
              title="Approve"
              onClick={() => {
                if (!isFinalStatus)
                  approveLeaveRequest(record.leave_application_id);
              }}
              style={{
                cursor: isFinalStatus ? "not-allowed" : "pointer",
              }}
            >
              <i className="ti ti-circle-check" />
            </Link>

            {/* Reject Icon */}
            <Link
              to="#"
              className="text-danger"
              title="Reject"
              onClick={() => {
                if (!isFinalStatus)
                  rejectLeaveRequest(record.leave_application_id);
              }}
              style={{
                cursor: isFinalStatus ? "not-allowed" : "pointer",
              }}
            >
              <i className="ti ti-circle-x" />
            </Link>
          </div>
        );
      },
    },
  ];

  const {
    data: approve_data,
    loading: approverLoading,
    error,
    callApi: callApproveApi,
  } = useApi("/api/manager/update-leave-request", {
    method: "POST",
    autoCall: false,
  });

  const approveLeaveRequest = async (leaveId: any) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to approve this leave request?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#28a745",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Approve",
      cancelButtonText: "Cancel",
    });

    // Proceed only if user confirms
    if (result.isConfirmed) {
      const payload = {
        leave_id: leaveId,
        status: "APPROVED",
      };

      try {
        const response = await callApproveApi(payload);

        if (response.statusCode === 200 || response.statusCode === 201) {
          Swal.fire({
            icon: response.success === true ? "success" : "error",
            title:
              response.success === true ? "Leave Approved" : "Approval Failed",
            text:
              response?.message ||
              "The leave request has been approved successfully.",
            showConfirmButton: true,
          });
        }
      } catch (err: any) {
        console.error("Failed to approve leave:", err);
        Swal.fire({
          icon: "error",
          title: "Approval Failed",
          text:
            err?.response?.data?.message ||
            "Something went wrong while approving the leave.",
        });
      }
    }
  };

  const rejectLeaveRequest = async (leaveId: any) => {
    const result = await Swal.fire({
      title: "Reject Leave Request",
      text: "Please provide a reason for rejection:",
      icon: "warning",
      input: "textarea",
      inputPlaceholder: "Enter detailed reason here...",
      inputAttributes: {
        "aria-label": "Rejection reason",
      },
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Reject",
      cancelButtonText: "Cancel",
      inputValidator: (value) => {
        if (!value.trim()) {
          return "Rejection reason is required!";
        }
        return null;
      },
    });

    if (result.isConfirmed && result.value) {
      const payload = {
        leave_id: leaveId,
        status: "REJECTED",
        rejected_reason: result.value,
      };

      try {
        const response = await callApproveApi(payload);

        Swal.fire({
          icon: response.success === true ? "success" : "error",
          title:
            response.success === true ? "Leave Rejected" : "Rejection Failed",
          text: response?.message || "The leave request has been rejected.",
          showConfirmButton: true,
        });
      } catch (err: any) {
        console.error("Failed to reject leave:", err);
        Swal.fire({
          icon: "error",
          title: "Rejection Failed",
          text:
            err?.response?.data?.message ||
            "Something went wrong while rejecting the leave.",
          showConfirmButton: true,
        });
      }
    }
  };

  const formatDate = (dateString: any) => {
    if (!dateString) return "N/A";
    return dayjs(dateString).format("DD MMMM YYYY"); // e.g., 16 October 2025
  };

  return (
    <>
      <Loader loading={leave_details_loading || approverLoading} />
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Application Detail</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.employeeDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Leave</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Application Detail List
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div>
                <Link
                  to="/leave-team-member"
                  className="btn btn-primary py-1 px-3"
                >
                  Back
                </Link>
              </div>
              <div className="me-2 mb-2"></div>
              <div className="input-icon w-120 position-relative mb-2">
                <span className="input-icon-addon">
                  <i className="ti ti-calendar text-gray-9" />
                </span>

              <select
                  value={finance_year}
                  onChange={(e) => setFinance_year(e.target.value)}
                  className="form-select"
                >
                  {getFinancialYearList().map((fy) => (
                    <option key={fy} value={fy}>
                      {fy.split("-")[0]}
                    </option>
                  ))}
                </select>
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-body p-0">
              <Table dataSource={data} columns={columns} Selection={false} showSearchInput={true} />
            </div>
          </div>
        </div>
        <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
          <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
        </div>
      </div>

      <div
        id="apply-modal"
        className="modal fade"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="apply-modalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header  text-white">
              <h5 className="modal-title" id="apply-modalLabel">
                Pending Leave Details
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-4 mb-3">
                  <strong>Employee ID:</strong>
                  <p className="text-muted">
                    {modalData?.employee_id || "N/A"}
                  </p>
                </div>
                <div className="col-md-4 mb-3">
                  <strong>Employee Name:</strong>
                  <p className="text-muted">
                    {modalData?.employee_name || "N/A"}
                  </p>
                </div>

                <div className="col-md-4 mb-3">
                  <strong>Leave Type:</strong>
                  <p className="text-muted">{modalData?.leave_type || "N/A"}</p>
                </div>

                <div className="col-md-4 mb-3">
                  <strong>Leave Slice:</strong>
                  <p className="text-muted">
                    {modalData?.leave_slice_type || "N/A"}
                  </p>
                </div>

                <div className="col-md-4 mb-3">
                  <strong>From Date:</strong>
                  <p className="text-muted">{formatDate(modalData?.from_date)}</p>
                </div>

                <div className="col-md-4 mb-3">
                  <strong>To Date:</strong>
                  <p className="text-muted">{formatDate(modalData?.to_date)}</p>
                </div>

                <div className="col-md-4 mb-3">
                  <strong>Number of Days:</strong>
                  <p className="text-muted">{modalData?.Days || "N/A"}</p>
                </div>

                <div className="col-md-4 mb-3">
                  <strong>Application Date:</strong>
                  <p className="text-muted">{formatDate(modalData?.application_date)}</p>
                </div>

                <div className="col-12 mb-3">
                  <strong>Reason:</strong>
                  <p className="text-muted">
                    {modalData?.application_reason || "N/A"}
                  </p>
                </div>
                <div className="col-md-4 mb-3">
                  <strong>CC Email:</strong>
                  <p className="text-muted">{modalData?.cc_email || "N/A"}</p>
                </div>

                <div className="col-md-4 mb-3">
                  <strong>Medical Certificate:</strong>
                  <p className="text-muted">
                    {modalData?.medical_certificate_file ? (
                      <a
                        href={modalData?.medical_certificate_file}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-primary"
                      >
                        View File
                      </a>
                    ) : (
                      "Not Provided"
                    )}
                  </p>
                </div>

                <div className="col-md-4 mb-3">
                  <strong>Status:</strong>
                  <p>
                    <span
                      className={`badge ${modalData?.status === "APPROVED"
                        ? "bg-success"
                        : modalData?.status === "REJECTED"
                          ? "bg-danger"
                          : "bg-warning text-dark"
                        }`}
                    >
                      {modalData?.status || "PENDING"}
                    </span>
                  </p>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        id="approve-modal"
        className="modal fade"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="approve-modalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header  text-white">
              <h5 className="modal-title" id="approve-modalLabel">
                Leave Application Approved
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="mb-3">
                <strong>Leave Reason:</strong>
                <p className="mb-0 text-muted">
                  {modalData?.application_reason || "N/A"}
                </p>
              </div>
              <div className="mb-3">
                <strong>Approved By:</strong>
                <p className="mb-0 text-muted">
                  {modalData?.approved_by_name === null
                    ? modalData?.approved_by
                    : modalData?.approved_by_name}
                </p>
              </div>

              <div className="mb-3">
                <strong>Approved On:</strong>
                <p className="mb-0 text-muted">
                  {modalData?.approved_on
                    ? dayjs(modalData.approved_on).format("DD-MMMM-YYYY hh:mm A")
                    : "N/A"}
                </p>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Rejected  */}
      <div
        id="rejected-modal"
        className="modal fade"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="rejected-modalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header text-white">
              <h5 className="modal-title" id="rejected-modalLabel">
                Leave Application Rejected
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="mb-3">
                <strong>Rejected By:</strong>
                <p className="mb-0 text-muted">
                  {modalData?.rejected_by_name === null
                    ? modalData?.rejected_by
                    : modalData?.rejected_by_name}
                </p>
              </div>

              <div className="mb-3">
                <strong>Rejection Reason:</strong>
                <p className="mb-0 text-muted">
                  {modalData?.rejection_reason || "N/A"}
                </p>
              </div>

              <div className="mb-3">
                <strong>Rejected On:</strong>
                <p className="mb-0 text-muted">
                  {modalData?.rejected_on
                    ? dayjs(modalData.rejected_on).format("DD-MMMM-YYYY hh:mm A")
                    : "N/A"}
                </p>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LeaveDetailTeamMember;
